import type { LitElement } from 'lit';

export type CustomerAttributeTargetType = ShadowRoot | LitElement | HTMLElement;

// Replace the <abbr data-coms-type="cattr" ...> tags with the <tef-coms-customer-attribute> tag
export const createCustomerAttributeInteraction = (target$ : CustomerAttributeTargetType) : number => {
  const cattrs$ = target$.querySelectorAll("[data-coms-type='cattr'],[data-coms-id]");
  cattrs$.forEach((cattrSpan$) => {
    const customerAttributeId = (cattrSpan$ as HTMLElement).dataset.comsId;
    if (!customerAttributeId) return;

    const customerDialogInnerContent$ = document.createElement('template');
    customerDialogInnerContent$.innerHTML = cattrSpan$.innerHTML;

    const customerDialog$ = document.createElement('tef-coms-customer-attribute');
    const id = (cattrSpan$ as HTMLElement).dataset.comsId!;
    customerDialog$.setAttribute('id', id);
    customerDialog$.appendChild(customerDialogInnerContent$);
    cattrSpan$.replaceWith(customerDialog$);
  });
  return cattrs$.length;
};
